import { useState, useMemo } from 'react';

import { Typography } from 'antd';

const { Text, Link } = Typography;

const ErrorListWithShowMore = ({
  errorList,
  showNumber = 5,
  fixedShowNumber,
}) => {
  const [showAll, setShowAll] = useState(false);

  const showErrorList = useMemo(() => {
    const showCount = fixedShowNumber || showNumber;
    return showAll ? errorList : errorList?.slice(0, showCount);
  }, [showAll, JSON.stringify(errorList), fixedShowNumber, showNumber]);

  const errorLeftCount = errorList?.length - showErrorList?.length;

  return (
    <div>
      {showErrorList?.map((errorItem, index) => {
        const { title, error } = errorItem || {};

        const isBrickCodeNameEmpty =
          title === 'Brick Code Name' && error === 'required field';

        const errorMessage = isBrickCodeNameEmpty
          ? 'Please update product brick code and re-validate'
          : error;

        return (
          <div key={index}>
            <Text strong>[{title}]</Text>
            <Text>: {errorMessage}</Text>
          </div>
        );
      })}

      {errorLeftCount > 0 && (
        <div>
          <Text strong>And {errorLeftCount} more error(s)...</Text>
        </div>
      )}

      {errorList?.length > showNumber && !fixedShowNumber && (
        <>
          {showAll ? (
            <Link onClick={() => setShowAll(false)}>Show less</Link>
          ) : (
            <Link onClick={() => setShowAll(true)}>Show all</Link>
          )}
        </>
      )}
    </div>
  );
};

export default ErrorListWithShowMore;
